module.exports = new __parcel__URL__("neon_gold_mine_level_11.d4ebc833.png").toString();